module.exports = __webpack_public_path__ + "static/media/ico_axis_512.cc5d8591.png";